import React, { useState, useEffect } from 'react';
import '../styles/components/OrderButton.css';

const OrderButton = ({ item }) => {
  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState(item.prices ? Object.keys(item.prices)[0] : null);
  const [isAdded, setIsAdded] = useState(false);
  const [currentPrice, setCurrentPrice] = useState(item.price);

  useEffect(() => {
    // Update price based on selected size for items with size-based pricing
    if (item.prices && item.prices[selectedSize]) {
      setCurrentPrice(item.prices[selectedSize]);
    }
  }, [selectedSize, item.prices]);

  const handleAddToCart = () => {
    const cartItem = {
      ...item,
      quantity,
      size: selectedSize,
      price: currentPrice,
      id: `${item.id}-${selectedSize}`
    };

    // Get existing cart
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');
    
    // Check if item already exists
    const existingItemIndex = cart.findIndex(i => i.id === cartItem.id);
    
    if (existingItemIndex >= 0) {
      cart[existingItemIndex].quantity += quantity;
    } else {
      cart.push(cartItem);
    }

    // Save to localStorage
    localStorage.setItem('cart', JSON.stringify(cart));

    // Dispatch event to update cart component
    window.dispatchEvent(new Event('cartUpdated'));

    // Show success feedback
    setIsAdded(true);
    setTimeout(() => setIsAdded(false), 2000);
  };

  // Only show size options for items with different sizes
  const showSizeOptions = item.prices && Object.keys(item.prices).length > 0;

  return (
    <div className="order-button-container">
      {showSizeOptions && (
        <div className="size-options">
          {Object.keys(item.prices || {}).map((size) => (
            <button
              key={size}
              className={`size-button ${selectedSize === size ? 'active' : ''}`}
              onClick={() => setSelectedSize(size)}
            >
              {size}
            </button>
          ))}
        </div>
      )}
      <div className="price-display">
        ${(currentPrice * quantity).toFixed(2)}
      </div>
      <div className="quantity-selector">
        <button 
          className="quantity-btn"
          onClick={() => quantity > 1 && setQuantity(q => q - 1)}
        >
          -
        </button>
        <span className="quantity">{quantity}</span>
        <button 
          className="quantity-btn"
          onClick={() => setQuantity(q => q + 1)}
        >
          +
        </button>
      </div>
      <button 
        className={`add-to-cart-btn ${isAdded ? 'added' : ''}`}
        onClick={handleAddToCart}
      >
        {isAdded ? 'Added to Cart!' : 'Add to Order'}
      </button>
    </div>
  );
};

export default OrderButton;
